import apiClient from '../client';
import type { Database } from '@/lib/supabase/supabase-types';

type FreelancerProfile = Database['public']['Tables']['freelancer_profiles']['Row'];

export interface SearchFilters {
  minHourlyRate?: number;
  maxHourlyRate?: number;
  skills?: string[];
  languages?: string[];
  availabilityStatuses?: string[];
}

export interface SearchResult extends FreelancerProfile {
  similarity_score: number;
  match_percentage: number;
}

export interface SearchRequest {
  jobDescription: string;
  similarityThreshold?: number;
  filters?: SearchFilters;
}

export interface SearchResponse {
  results: SearchResult[];
  query: string;
  timestamp: string;
  totalResults: number;
}

export interface SearchHistoryResult {
  searchQuery: string;
  searchTime: string;
  languages: string[];
  skills: string[];
  minRate: number | null;
  maxRate: number | null;
}

export const searchService = {
  /**
   * Perform semantic search for freelancer profiles
   * @param searchRequest - Search parameters including job description and filters
   */
  searchGeniuses: (searchRequest: SearchRequest): Promise<SearchResponse> =>
    apiClient.post<SearchResponse>('/search/genius', searchRequest) as unknown as Promise<SearchResponse>,

  /**
   * Get public search history (freelancers only)
   */
  getSearchHistory: (): Promise<{ searches: SearchHistoryResult[] }> =>
    apiClient.get<{ searches: SearchHistoryResult[] }>('/search/history') as unknown as Promise<{ searches: SearchHistoryResult[] }>,
};

